(function(Menu) {
    'use strict';

    // The elements of the slider.
    Menu.elements = {
        menu: '.js-menu-responsive .menu-item-has-children > a'
    };

    Menu.openSubmenu = function(event) {
        event.preventDefault();
        $(Menu.elements.menu).parent().removeClass('is-active');
        $(this).parent().addClass('is-active');
    };

    Menu.init = function() {
        var mediaQuery = window.matchMedia(Way2web.config.breakpoints.portable);

        if (mediaQuery.matches) {
            $(Menu.elements.menu).one('click', Menu.openSubmenu);
        }
    };


// Create the handler.
    Way2web.handlers.menu = Menu.init;
})(window.Way2web.Menu = window.Way2web.Menu || {});
